<template>
  <div id="app">
    <v-app>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <link rel="stylesheet" href="https://use.typekit.net/cty2rhd.css" />
      <div class="oo-page" v-if="showApp()">
        <v-navigation-drawer
          :v-model="null"
          color="#f2eae2"
          app
          mobile-break-point="960"
        >
          <navigation-bar-base></navigation-bar-base>
        </v-navigation-drawer>

        <v-app-bar
          app
          color="white"
          src="/seedling.png"
          flat
          fade-img-on-scroll
          shrink-on-scroll
          :height="title ? '128px' : '90px'"
        >
          <template v-slot:img="{ props }">
            <v-img
              v-bind="props"
              :contain="true"
              class="seedling-image"
            ></v-img>
          </template>
          <v-menu v-if="$vuetify.breakpoint.smAndDown" :absolute="true">
            <template v-slot:activator="{ on }">
              <v-btn icon text large v-on="on" id="js-nav-menu">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>
            <navigation-menu-base></navigation-menu-base>
          </v-menu>
          <v-toolbar-title
            ><div
              id="js-title"
              class="text-uppercase toolbar-title"
              v-if="title"
            >
              {{ title }}
            </div>
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-icon
            v-if="unreadNotificationsCount > 0"
            color="red"
            @click="goToNotifications"
          >
            {{ unreadNotificationsIcon }}
          </v-icon>
          <v-menu :absolute="true">
            <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-avatar
                    size="44px"
                    v-on="{ ...tooltip, ...menu }"
                    class="current_user"
                  >
                    <img :src="avatar" alt="avatar missing?" />
                  </v-avatar>
                </template>
                <span>
                  {{ currentUser }}
                </span>
              </v-tooltip>
            </template>

            <v-list class="user-menu">
              <v-list-item
                class="user-menu-item d-flex justify-center"
                @click="$router.push({ path: `/user` })"
              >
                <span class="user-menu-item-text">
                  Profile
                </span>
              </v-list-item>
              <v-list-item
                class="user-menu-item d-flex justify-center"
                @click="logout()"
              >
                <span class="user-menu-item-text">
                  Logout
                </span>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-app-bar>
        <v-content app>
          <v-container fluid>
            <mobile-switcher
              v-if="$vuetify.breakpoint.smAndDown"
            ></mobile-switcher>
            <base-alert></base-alert>
            <router-view />
          </v-container>
        </v-content>
        <v-footer
          v-if="false"
          app
          padless
          color="white"
          height="40px"
          class="mx-auto"
        >
          <status-bar></status-bar>
        </v-footer>
      </div>
      <div class="oo-container" v-else>
        <router-view />
      </div>
      <status-bar v-if="false"></status-bar>
    </v-app>
  </div>
</template>

<script>
import BaseAlert from "@/components/BaseAlert"
import NavigationBarBase from "@/containers/navigations/NavigationBarBase"
import NavigationMenuBase from "@/containers/navigations/NavigationMenuBase"
import EventBus from "@/lib/eventBus"
import User from "@/lib/user"
import StatusBar from "@/containers/StatusBar"
import FlashAlert from "@/components/FlashAlert"
import MobileSwitcher from "@/containers/navigations/MobileSwitcher"
import { getCookie } from "tiny-cookie"
// import BrowserNotifications from "@/lib/BrowserNotifications"

export default {
  components: {
    BaseAlert,
    NavigationBarBase,
    NavigationMenuBase,
    MobileSwitcher,
    FlashAlert,
    StatusBar
  },
  computed: {
    avatar() {
      let user = this.$store.getters["users/getMe"]
      return user ? user.avatar : ""
    },
    unreadNotificationsCount() {
      return this.$store.getters["notifications/getNotifications"].filter(
        el => !el.read
      ).length
    },
    newNotifications() {
      return this.$store.getters["notifications/getNewNotifications"]
    },
    unreadNotificationsIcon() {
      const i = this.unreadNotificationsCount
      let s = "mdi-numeric-9-plus-circle-outline"

      if (i < 9) {
        s = `mdi-numeric-${i}-circle-outline`
      }
      return s
    }
  },
  data: function() {
    return {
      title: undefined,
      loggedIn: false,
      flashOptions: { text: "", type: "info", visible: false },
      currentUser: "",
      overwriteBreakpoint: false
    }
  },
  watch: {
    newNotifications(val) {
      if (val.length > 0) {
        val.forEach(e => {
          // BrowserNotifications.send(e.title, e.body)
        })
      }
    }
  },
  created: function() {
    this.checkLogin()

    EventBus.$on("title", title => {
      this.title = title
    })
    EventBus.$on("login", () => {
      this.loggedIn = true
      //TODO: This may not be the usage we want!
      this.$router.push("/")
    })
    EventBus.$on("flash", options => {
      this.flashOptions = options
    })

    if (this.loggedIn) {
      this.$store.dispatch("notifications/loadNotifications")
    }
  },
  beforeUpdate: function() {
    this.checkLogin()
  },
  methods: {
    showApp: function() {
      let name = this.$router.history.current.name
      return (
        this.loggedIn && !["about", "restricted", "serverDown"].includes(name)
      )
    },
    logout: function() {
      this.$router.push({ name: "logout" })
    },
    toggleBar: function() {
      this.overwriteBreakpoint = !this.overwriteBreakpoint
    },
    checkLogin: function() {
      this.loggedIn = User.isLoggedIn()
      if (this.loggedIn) {
        this.type = User.getUserType()
        this.currentUser = User.name()
        this.userId = User.getUserId()

        if (getCookie("userMode")) {
          this.$store.commit("globals/setUserMode", getCookie("userMode"))
        }
        this.$store.dispatch("users/loadMe")
      }
    },
    isMember: function() {
      return User.isMember()
    },
    isManager: function() {
      return User.isManager()
    },
    isPresident: function() {
      return User.isPresident()
    },
    goToNotifications() {
      this.$store.commit("globals/setUserMode", "MANAGE")
      this.$router.push({ name: "dashboardManager" })
    }
  },
  errorCaptured: (err, vm, info) => {
    console.log(err)
  },
  mounted: function() {
    this.$cable.subscribe({ channel: "NotificationsChannel", room: "public" })
  },
  channels: {
    NotificationsChannel: {
      connected() {
        console.log("Connected to Notifications Channel")
      },
      received(data) {
        if (data.user_id == this.userId) {
          this.$store.dispatch("notifications/loadNotifications")
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "~vuetify/src/styles/settings/_variables.scss";
@import "scss/variables";

i.mdi-menu {
  color: $dark-grey !important;
}
.current_user {
  margin: 10px;
  cursor: pointer;
}

header.v-sheet {
  display: flex;
  justify-content: center;
}
main.v-content {
  background-color: $main-bg-color;
  height: 100%;
  display: flex;
  justify-content: center;
}
div.v-content__wrap {
  max-width: map-get($grid-breakpoints, "md");
}

.v-toolbar__content {
  width: 100%;
  max-width: map-get($grid-breakpoints, "md");
}

.v-application {
  font-family: $main-font-family !important;
  background-color: $main-bg-color !important;
}

.toolbar-title {
  font-weight: 700;
  color: $orange;
  text-align: center;
  width: 100%;
}
.profile_link {
  text-decoration: none;
}

.v-navigation-drawer__border {
  border: 1px solid $nav-background;
}

.page-content {
  min-width: 80%;
  max-width: 820px;
}

.oo-container {
  margin: 0px auto;
  font-family: $main-font-family;
  background-color: $nav-background;
  height: 100%;
  width: 100%;
}

.oo-page {
  height: 100%;
}
.v-app-bar__nav-icon {
  margin-left: 20px;
  margin-top: 20px;
}
.v-avatar {
  margin: 0 5px 0 0;
}
.seedling-image {
  height: 74px !important;
  border-bottom: 1.5px solid $off-white;
}

div.v-toolbar__title {
  width: 100%;
}

div.v-image__image {
  // border-bottom: 1.5px solid $off-white;
}

.user-menu {
  background-color: $nav-background !important;
  text-transform: uppercase !important;
  width: 170px;
}

.user-menu-item {
  font-weight: 600;
  letter-spacing: 1.5px;
  border-bottom: 1px solid $main-bg-color;
}

.user-menu-item-text {
  color: $dark-grey;
}

.user-menu-item:last-child {
  border: 0px;
}

ul {
  list-style: circle !important;
}
</style>
